import React from 'react';

import { CachedImage } from '@components/molecules/CachedImage';

import * as S from './styles';
import { IProps } from './types';

export const ProductImage: React.FC<IProps> = ({ image }: IProps) => (
  <S.Preview>
    {image && <CachedImage alt={image.alt} url={image.url} />}
    {!image && <CachedImage />}
  </S.Preview>
);
